/* eslint-disable no-undef */
if (window.__POWERED_BY_QIANKUN__) {
  // eslint-disable-next-line no-undef
  // eslint-disable-next-line camelcase
  __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__;
}
